import {
    SalesRevenueByCompanyAllMapType,
    SalesRevenueByCompanyAllType,
    SalesRevenueByCompanyCreateElementType,
    SalesRevenueByCompanyCreateMapType,
    SalesRevenueByCompanyExpectedExcelResType,
    SalesRevenueByCompanyType,
    SalesRevenueViewInfoElementType,
    SalesSearchParamType
} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import { useExportRevenueByCompanyExcel } from "../hooks/useExportRevenueByCompanyExcel";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import { Control, UseFormRegister, UseFormSetValue } from "react-hook-form";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import React, { useMemo, useState } from "react";
import { salesRevenueByCompanyAllInit } from "../state";
import { useUser } from "../../../../../util/userContext/UserContext";
import { useReadNewProductGroup } from "../../expected/hooks/useReadNewProductGroup";
import { useModal } from "../../../../../hooks";
import { SearchBusinessPartnerInner } from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import { SearchErpInner } from "../../../../../components/common/modal/inner/SearchErpInner";
import { useReadRevenueLastYear } from "../../expected/hooks/useReadRevenueLastYear";
import { useUploadRevenueByCompanyExcel } from "../../expected/hooks/useUploadRevenueByCompanyExcel";
import moment from "moment";
import { useCreateRevenueByCompany } from "../../expected/hooks/useCreateRevenueByCompany";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    searchParam: SalesSearchParamType
    dataList: SalesRevenueByCompanyAllType[]
    hiddenColumnData: SalesRevenueViewInfoElementType[]
    monthView: "expected" | "full" | "filtered" | "one"
    isEdit?: boolean
    editData?: SalesRevenueByCompanyAllMapType
    register?: UseFormRegister<SalesRevenueByCompanyAllMapType>;
    setValue?: UseFormSetValue<SalesRevenueByCompanyAllMapType>;
    control?: Control<SalesRevenueByCompanyAllMapType>
}

export default function Tab2({
    searchParam,
    dataList,
    hiddenColumnData,
    monthView,
    isEdit,
    editData,
    register,
    setValue,
    control
}: PropsType) {
    const { handleModal } = useModal();
    const { goToNavigation } = useGoToNavigation();
    const { user } = useUser()

    const [selectedItem, setSelectedItem] = useState<number[]>([])

    const isAllCheck = dataList.length !== 0 && dataList.length === selectedItem.length

    const clickAllCheck = () => {
        if (isAllCheck) {
            setSelectedItem([])
        } else {
            setSelectedItem(Array.from({ length: dataList.length }, (_, idx) => idx))
        }
    }

    const clickCheck = (idx: number) => {
        if (selectedItem.includes(idx)) {
            const list = selectedItem.filter(el2 => idx !== el2)

            setSelectedItem(list)
        } else {
            setSelectedItem([...selectedItem, idx])
        }
    }

    const { data: categoryList } = useReadNewProductGroup({ enabled: monthView === "expected" })
    const categoryOption = useMemo(() =>
        <>
            <option value={""}>선택</option>
            {categoryList?.map((el: any) => <option value={el.newProductGroupid}>{el.newName}</option>)}
        </>
        , [categoryList])

    const onChangeCategory = (e: React.ChangeEvent<HTMLSelectElement>, idx: number) => {
        const { value } = e.target

        const item = categoryList?.find((el: any) => el.newProductGroupid == value)

        if (editData && item) {
            const list = editData.searchAllRevenueResList.map((el, idx2) => {
                if (idx === idx2) {
                    return {
                        ...el,
                        newProductGroupid: value,
                        category: value,
                        categoryName: item.newName ?? "",
                        vendor: item.vendor ?? "",
                        vendorName: item.vendor ?? ""
                    }
                } else {
                    return el
                }
            })

            setValue && setValue("searchAllRevenueResList", list)
        }
    }

    // 고객사
    const btnFindCustomerAccounts = (idx: number) => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        console.log(item);

                        if (editData) {
                            const list = editData.searchAllRevenueResList.map((el, idx2) => {
                                if (idx === idx2) {
                                    return {
                                        ...el,
                                        customerAccountsId: item.accountId,
                                        customerAccountsName: item.erpAccountName
                                    }
                                } else {
                                    return el
                                }
                            })

                            setValue && setValue("searchAllRevenueResList", list)
                        }
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "고객사 조회",
            modalSize: "xxl",
        });
    }

    // 납품처
    const btnFindShipErpAccount = (idx: number) => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchErpInner
                    confirmCallback={(item) => {
                        console.log(item)

                        if (editData) {
                            const list = editData.searchAllRevenueResList.map((el, idx2) => {
                                if (idx === idx2) {
                                    return {
                                        ...el,
                                        shipErpAccountId: item.new_erp_accountid ?? item.newErpAccountId ?? "",
                                        shipErpAccountName: item.new_txt_nm_partner ?? item.newTxtNmPartner ?? ""
                                    }
                                } else {
                                    return el
                                }
                            })

                            setValue && setValue("searchAllRevenueResList", list)
                        }
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "ERP거래처 조회",
            modalSize: "xl",
        })
    }

    // 거래처
    const btnFindRevenueErpAccount = (idx: number) => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchErpInner
                    confirmCallback={(item) => {
                        console.log(item)

                        if (editData) {
                            const list = editData.searchAllRevenueResList.map((el, idx2) => {
                                if (idx === idx2) {
                                    return {
                                        ...el,
                                        revenueErpAccountId: item.new_erp_accountid ?? item.newErpAccountId ?? "",
                                        revenueErpAccountName: item.new_txt_nm_partner ?? item.newTxtNmPartner ?? ""
                                    }
                                } else {
                                    return el
                                }
                            })

                            setValue && setValue("searchAllRevenueResList", list)
                        }
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "거래처 조회",
            modalSize: "xl",
        })
    }

    const goToExpected = () => {
        goToNavigation("main/sales/expected", {}, false)
    }
    const btnNewTab = () => {
        // goToNavigation("main/sales/company", {
        //     stateSearchParam: {
        //         ...searchParam,
        //         teamId: "",
        //         handlerId: searchParam.handlerId
        //     }
        // }, false)
        window.open(`/main/sales/company?handlerId=${searchParam.handlerId}`, '_blank');  // 새 탭에서 열기
    }
    const goToColumn = () => {
        goToNavigation("main/sales/column", {}, false)
    }

    const { mutate: mutateExportRevenueByCompanyExcel } = useExportRevenueByCompanyExcel()
    const btnExportExcel = () => {
        mutateExportRevenueByCompanyExcel(searchParam)
    }

    const { mutate: mutateCreateRevenueByCompany } = useCreateRevenueByCompany()
    const btnSave = () => {
        if (editData) {
            if (editData.searchAllRevenueResList.length === 0) {
                handleModal({
                    isOpen: true,
                    contents: "입력한 항목이 없습니다.",
                    type: "alert"
                })
            } else {
                const param: SalesRevenueByCompanyCreateMapType = {
                    revenueYear: moment().year(),
                    revenueDataReqList: editData.searchAllRevenueResList.map(el => {
                        const revenueByMonthMap: Record<number, SalesRevenueByCompanyCreateElementType> = el.revenueDataMapList.reduce((acc, {
                            month,
                            revenueData
                        }) => {
                            acc[month] = { ...revenueData };

                            return acc;
                        }, {} as Record<number, SalesRevenueByCompanyCreateElementType>)

                        return {
                            category: el.category,
                            customerAccountsId: el.customerAccountsId,
                            newProductGroupid: el.newProductGroupid,
                            revenueErpAccountId: el.revenueErpAccountId,
                            shipErpAccountId: el.shipErpAccountId,
                            vendor: el.vendor,
                            revenueByMonthMap: revenueByMonthMap,
                        }
                    }),
                }

                mutateCreateRevenueByCompany(param)
            }
        }
    }

    const goToList = () => {
        if (editData?.searchAllRevenueResList.length !== 0) {
            handleModal({
                isOpen: true,
                contents: "입력을 취소하시겠습니까?",
                type: "confirm",
                callback: () => goToNavigation("main/sales/list", {}, true)
            })
        } else {
            goToNavigation("main/sales/list", {}, true)
        }
    }

    const { mutateAsync: mutateAsyncUploadRevenueByCompanyExcel } = useUploadRevenueByCompanyExcel()
    const btnImportExcel = (file: File[]) => {
        const fd = new FormData()
        file.map(el => fd.append("excelFile", el))

        mutateAsyncUploadRevenueByCompanyExcel(fd).then(res => {
            if (res.data.code === "0000") {
                const resList: SalesRevenueByCompanyExpectedExcelResType[] = res.data.result?.revenueForInputExcelVOList ?? []

                if (resList.length !== 0) {
                    const list: SalesRevenueByCompanyAllType[] = resList.map(el => {
                        const categoryItem = categoryList?.find((el2: any) => el2.newProductGroupid == el.newProductGroupid)

                        return {
                            ...salesRevenueByCompanyAllInit,
                            customerAccountsId: el.customerAccountsId,
                            customerAccountsName: el.customerAccountsName,
                            revenueErpAccountId: el.revenueErpAccountId,
                            revenueErpAccountName: el.revenueErpAccountName,
                            shipErpAccountId: el.shipErpAccountId,
                            shipErpAccountName: el.shipErpAccountName,
                            newProductGroupid: el.newProductGroupid,
                            category: el.newProductGroupid,
                            categoryName: categoryItem.newName ?? "",
                            vendor: categoryItem.vendor ?? "",
                            vendorName: categoryItem.vendor ?? "",
                            revenueDataMapList: [
                                {
                                    month: 1,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueJanuary,
                                        revenueGoal: el.revenueGoalJanuary,
                                    }
                                },
                                {
                                    month: 2,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueFebruary,
                                        revenueGoal: el.revenueGoalFebruary,
                                    }
                                },
                                {
                                    month: 3,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueMarch,
                                        revenueGoal: el.revenueGoalMarch,
                                    }
                                },
                                {
                                    month: 4,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueApril,
                                        revenueGoal: el.revenueGoalApril,
                                    }
                                },
                                {
                                    month: 5,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueMay,
                                        revenueGoal: el.revenueGoalMay,
                                    }
                                },
                                {
                                    month: 6,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueJune,
                                        revenueGoal: el.revenueGoalJune,
                                    }
                                },
                                {
                                    month: 7,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueJuly,
                                        revenueGoal: el.revenueGoalJuly,
                                    }
                                },
                                {
                                    month: 8,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueAugust,
                                        revenueGoal: el.revenueGoalAugust,
                                    }
                                },
                                {
                                    month: 9,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueSeptember,
                                        revenueGoal: el.revenueGoalSeptember,
                                    }
                                },
                                {
                                    month: 10,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueOctober,
                                        revenueGoal: el.revenueGoalOctober,
                                    }
                                },
                                {
                                    month: 11,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueNovember,
                                        revenueGoal: el.revenueGoalNovember,
                                    }
                                },
                                {
                                    month: 12,
                                    revenueData: {
                                        actualRevenue: 0,
                                        estimatedRevenue: el.estimatedRevenueDecember,
                                        revenueGoal: el.revenueGoalDecember,
                                    }
                                },

                            ]
                        }
                    })

                    if (editData && setValue) {
                        setValue("searchAllRevenueResList", [...editData.searchAllRevenueResList, ...list])
                    }
                }
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert"
                })
            }
        })
    }

    const btnAdd = () => {
        if (editData && setValue) {
            setValue("searchAllRevenueResList", [...editData.searchAllRevenueResList, salesRevenueByCompanyAllInit])
        }
    }

    const btnCopySelected = () => {
        if (editData && setValue) {
            const list = dataList.filter((el, idx) => selectedItem.includes(idx))

            setValue("searchAllRevenueResList", [...editData.searchAllRevenueResList, ...list])

            setSelectedItem([])
        }
    }

    const { mutateAsync: mutateAsyncReadRevenueLastYear } = useReadRevenueLastYear()
    const btnCopyPreviousYear = () => {
        if (setValue) {
            mutateAsyncReadRevenueLastYear().then(res => {
                if (res.data.code === "0000") {
                    const list = res.data.result.searchLastYearDataResList as SalesRevenueByCompanyAllType[]
                    setValue("searchAllRevenueResList", [...(editData?.searchAllRevenueResList ?? []), ...list])
                }
            })
        }
    }

    const btnDeleteSelected = () => {
        if (editData && setValue) {
            const list = dataList.filter((el, idx) => !selectedItem.includes(idx))

            setValue("searchAllRevenueResList", list)

            setSelectedItem([])
        }
    }

    const leftThColGroupRenderer = () => {
        return <colgroup>
            {monthView === "expected" && <col style={{ width: "4%" }} />}
            <col style={{ width: "8%" }} />
            <col style={{ width: "22%" }} />
            <col style={{ width: "22%" }} />
            <col style={{ width: "22%" }} />
            <col style={{ width: "11%" }} />
            <col style={{ width: "11%" }} />
        </colgroup>
    }

    const leftThRenderer = () => {
        if (monthView === "expected") {
            const list = hiddenColumnData.filter(el => el.revenueViewInfoId < 7)

            return <>
                <th>
                    <div className="checkbox_outer">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isAllCheck}
                            onClick={clickAllCheck}
                        />
                    </div>
                </th>
                {list.map((el, idx) =>
                    <th className={idx === list.length - 1 ? "border-right-1" : ""}>{el.target}</th>)
                }
            </>
        } else {
            const list = hiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId < 7)

            return <>{
                list.map((el, idx) =>
                    <th className={idx === list.length - 1 ? "border-right-1" : ""}>{el.target}</th>)
            }</>
        }
    }

    const leftTdRenderer = ({ idx }: { idx: number }) => {
        const editedHiddenColumnData = hiddenColumnData.map(el => {
            switch (el.revenueViewInfoId) {
                case 1:
                    return { ...el, key: "handlerName", className: "text-center" };
                case 2:
                    return { ...el, key: "customerAccountsName", className: "text-center" };
                case 3:
                    return { ...el, key: "revenueErpAccountName", className: "text-center" };
                case 4:
                    return { ...el, key: "shipErpAccountName", className: "text-center" };
                case 5:
                    return { ...el, key: "vendor", className: "text-center" };
                case 6:
                    return { ...el, key: "category", className: "text-center" };
                default:
                    return { ...el, key: "", className: "" }
            }
        })

        if (monthView === "expected") {
            if (editData) {
                const data = editData.searchAllRevenueResList.at(idx) as SalesRevenueByCompanyAllType

                return <>
                    <td className="text-center">
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedItem.includes(idx)}
                                onClick={() => clickCheck(idx)}
                            />
                        </div>
                    </td>
                    <td className="text-center w-80px">{user?.userName}</td>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text"
                                className="form-control"
                                value={data.customerAccountsName}
                                disabled
                            />
                            <button className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnFindCustomerAccounts(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />찾기
                            </button>
                        </div>
                    </td>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text"
                                className="form-control"
                                value={data.revenueErpAccountName}
                                disabled
                            />
                            <button className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnFindRevenueErpAccount(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />찾기
                            </button>
                        </div>
                    </td>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text"
                                className="form-control"
                                value={data.shipErpAccountName}
                                disabled
                            />
                            <button className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnFindShipErpAccount(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />찾기
                            </button>
                        </div>
                    </td>
                    <td className="p-4px">
                        <input type="text"
                            className="form-control"
                            value={data.vendor}
                            disabled
                        />
                    </td>
                    <td className="p-4px">
                        <select className="form-select"
                            value={data.newProductGroupid}
                            onChange={e => onChangeCategory(e, idx)}
                        >
                            {categoryOption}
                        </select>
                    </td>
                </>
            }
        } else {
            const list = editedHiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId < 7)

            return <>{
                list.map((el, idx2) => <td
                    className={idx2 === list.length - 1 ? `border-right-1 ${el.className}` : `${el.className}`}>{dataList.at(idx)?.[el.key as keyof (SalesRevenueByCompanyType | SalesRevenueByCompanyAllType)]}</td>)
            }</>
        }
    }

    const rightThRenderer = () => {
        const firstRow = []
        const secondRow = []
        const secondRowElement = <>
            <th>경영 목표</th>
            <th>예상 매출</th>
            <th>실 매출</th>
        </>

        if (monthView === "one") {
            firstRow.push(<th colSpan={3}>{searchParam.revenueMonth}월</th>)
            secondRow.push(secondRowElement)
        } else if (monthView === "filtered") {
            const list = hiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId >= 7)

            list.map(el => {
                firstRow.push(<th colSpan={3}>{el.target}</th>)
                secondRow.push(secondRowElement)
            })
        } else if (monthView === "full" || monthView === "expected") {
            const list = hiddenColumnData.filter(el => el.revenueViewInfoId >= 7)

            list.map(el => {
                firstRow.push(<th colSpan={3}>{el.target}</th>)
                secondRow.push(secondRowElement)
            })
        }

        return <>
            <tr>
                {firstRow}
            </tr>
            <tr>
                {secondRow}
            </tr>
        </>
    }

    const rightTdRenderer = ({ idx }: { idx: number }) => {
        const row: any[] = []

        if (monthView === "one") {
            const data = dataList[idx] as SalesRevenueByCompanyAllType
            const ed = editData?.searchAllRevenueResList[idx] as SalesRevenueByCompanyAllType

            data.revenueDataMapList.map((el, idx2) => {
                row.push(!isEdit && el.month == searchParam.revenueMonth ? <>
                    <td className="text-center"><DisplayNumber value={el.revenueData.revenueGoal} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.estimatedRevenue} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.actualRevenue} /></td>
                </> : register && el.month == searchParam.revenueMonth && <>
                    <td className="p-4px">
                        {control && <InputNumberUc control={control}
                            name={`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.revenueGoal`} />}
                        {/*<input type="text"
                                   className="form-control text-center"
                                   value={ed.revenueDataMapList.at(idx2)?.revenueData.revenueGoal}
                                   {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.revenueGoal`)}
                            />*/}
                    </td>
                    <td className="p-4px">
                        {control && <InputNumberUc control={control}
                            name={`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.estimatedRevenue`} />}
                        {/*<input type="text"
                                   className="form-control text-center"
                                   value={ed.revenueDataMapList.at(idx2)?.revenueData.estimatedRevenue}
                                   {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.estimatedRevenue`)}
                            />*/}
                    </td>
                    <td className="p-4px">
                        <input type="text"
                            className="form-control text-center"
                            value={ed.revenueDataMapList.at(idx2)?.revenueData.actualRevenue}
                            {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.actualRevenue`)}
                            disabled
                        />
                    </td>
                </>)
            })
        } else if (monthView === "filtered") {
            const list = hiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId >= 7)
            const data = dataList[idx] as SalesRevenueByCompanyAllType
            const list2 = data.revenueDataMapList.filter(el => list.map(el2 => el2.revenueViewInfoId - 6).includes(el.month))

            list2.map(el => {
                row.push(<>
                    <td className="text-center"><DisplayNumber value={el.revenueData.revenueGoal} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.estimatedRevenue} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.actualRevenue} /></td>
                </>)
            })
        } else if (monthView === "full") {
            const data = dataList[idx] as SalesRevenueByCompanyAllType

            data.revenueDataMapList.map(el => {
                row.push(<>
                    <td className="text-center"><DisplayNumber value={el.revenueData.revenueGoal} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.estimatedRevenue} /></td>
                    <td className="text-center"><DisplayNumber value={el.revenueData.actualRevenue} /></td>
                </>)
            })
        } else if (monthView === "expected") {
            const ed = editData?.searchAllRevenueResList[idx] as SalesRevenueByCompanyAllType

            ed.revenueDataMapList.map((el, idx2) =>
                register && row.push(<>
                    <td className="p-4px">
                        {control && <InputNumberUc control={control}
                            name={`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.revenueGoal`} />}
                        {/*<input type="text"
                                   className="form-control text-center"
                                   value={ed.revenueDataMapList.at(idx2)?.revenueData.revenueGoal}
                                   {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.revenueGoal`)}
                            />*/}
                    </td>
                    <td className="p-4px">
                        {control && <InputNumberUc control={control}
                            name={`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.estimatedRevenue`} />}
                        {/*<input type="text"
                                   className="form-control text-center"
                                   value={ed.revenueDataMapList.at(idx2)?.revenueData.estimatedRevenue}
                                   {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.estimatedRevenue`)}
                            />*/}
                    </td>
                    <td className="p-4px">
                        <input type="text"
                            className="form-control text-center"
                            value={ed.revenueDataMapList.at(idx2)?.revenueData.actualRevenue}
                            {...register(`searchAllRevenueResList.${idx}.revenueDataMapList.${idx2}.revenueData.actualRevenue`)}
                            disabled
                        />
                    </td>
                </>)
            )
        }

        return <>
            {row.map((item) => (
                <>{item}</>
            ))}
        </>
    }

    return <div className="content_wrap">
        {monthView === "expected" && <div className="fiter_top">
            <h3 className="filter_heading">예상 매출 입력</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-240px h-38px" onClick={goToList}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록
                </button>
                <button className="btn btn-primary w-100px h-38px"
                    onClick={btnSave}>저장
                </button>
            </div>
        </div>}
        <div className="table_top">
            <h6 className="table_stats">예상 매출 목록</h6>
            <div className="table_toolbar">
                {(monthView === "filtered" || monthView === "one") && <>
                    <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel} disabled={isEdit}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기
                    </button>
                    <AuthorityChecker authorityNames={['salesWriteYn']}>
                        <button className="btn btn-primary ms-40px" onClick={goToExpected}>예상 매출 입력</button>
                    </AuthorityChecker>
                    <button className="btn btn-primary color2" onClick={btnNewTab}>새 창에서 보기</button>
                    <button className="btn btn-outline-primary" onClick={goToColumn}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt="" />컬럼설정
                    </button>
                </>}

                {monthView === "expected" && <>
                    <FileUploadNoText
                        addFileCallback={(file: File[]) => btnImportExcel(file)}
                        customRenderer={(onClick: any, disabled: any) =>
                            <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기
                            </button>

                        }
                        accept={".xlsx, .xls"}
                    />
                    <button className="btn btn-primary w-80px px-0 ms-40px" onClick={btnAdd}>추가</button>
                    <button className="btn btn-primary w-80px px-0" onClick={btnCopySelected}>선택 복사</button>
                    <button className="btn btn-info color-2 px-2" onClick={btnCopyPreviousYear}>전년도 데이터 복사</button>
                    <button className="btn btn-outline-dark" onClick={btnDeleteSelected}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제
                    </button>
                </>}
            </div>
        </div>

        <div className="tables_container table-sticky" style={{ clear: "both" }}>
            {dataList.length !== 0
                ? <>
                    <div className="left" style={{ width: "956px" }}>
                        <table className="table table-bordered my_table my_table_2lines mb-0">
                            {leftThColGroupRenderer()}
                            <thead>
                                <tr className="h-68px">
                                    {leftThRenderer()}
                                </tr>
                            </thead>
                            <tbody>
                                {dataList.map((el, idx) => (
                                    <tr>
                                        {leftTdRenderer({ idx })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="table_scroll right mb-0">
                        <table className="table table-bordered my_table my_table_2lines"
                            style={{
                                minWidth: "unset", width:
                                    monthView === "one"
                                        ? 630
                                        : monthView === "filtered"
                                            ? (hiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId >= 7)).length * 630
                                            : (12 * 630)
                                            + "px"
                            }}>
                            <thead>
                                {rightThRenderer()}
                            </thead>
                            <tbody>
                                {dataList.map((el, idx) => (<tr>
                                    {rightTdRenderer({ idx })}
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
                : <table className="table table-bordered my_table my_table_2lines mb-0">
                    <thead>
                        <tr className="h-68px">
                            {leftThRenderer()}
                        </tr>
                    </thead>
                    <tbody>
                        <EmptyTableRow
                            colSpan={hiddenColumnData.filter(el => el.isHidden === "N" && el.revenueViewInfoId < 7).length + 1}
                            msg={monthView === "expected" ? "항목이 없습니다." : undefined} />
                    </tbody>
                </table>
                
            }
        </div>
    </div>
}